import { HttpErrorResponse } from '@angular/common/http';

export class HttpError {
  static fromDto(dto: HttpErrorResponse): HttpError {
    return new HttpError(dto.error.message, dto.error.status, dto.url);
  }

  constructor(
    public message: string,
    public status: number,
    public url: string | null,
  ) {}

  isApiError(): boolean {
    if (this.url === null) {
      return false;
    } else if (this.url.includes('/proxy/')) {
      return true;
    } else if (this.url.includes('api-') && this.url.includes('.infano.io')) {
      return true;
    }
    return false;
  }

  is4xx(): boolean {
    return this.status >= 400 && this.status <= 499;
  }

  is5xx(): boolean {
    return this.status >= 500 && this.status <= 599;
  }

  getMessage(): string {
    if (this.is4xx()) {
      return this.message;
    } else {
      return `${this.message}`;
    }
  }
}
